import * as React from "react";
import { useRef, useState, useEffect } from "react";
import { DropDownBox, List } from "devextreme-react";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";

const filterOptionsList = [
  "Start Date",
  "End Date",
  "Usernames",
  "Last Login Date",
  "Roles",
  "Regions",
  "User Statuses",
  "Job Title",
  "Deactivation Date",
  "Reactivation Date",
  "Creation Date",
  "Termination Date",
  "Suspension Date",
];

const SearchBtnGroupSelect = ({ value, setter }) => {
  const dropDownBoxRef = useRef(null);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [opened, setOpened] = useState(false);

  useEffect(() => {
    setSelectedKeys(value || []);
  }, [value]);

  const onSelectionChanged = (e) => {
    const newSelected = e.component.option("selectedItemKeys");
    setSelectedKeys(newSelected);
    setter(newSelected);

    const listItems = document.querySelectorAll(".dx-list .dx-checkbox");
    listItems.forEach((checkbox, index) => {
      const itemName = filterOptionsList[index];
      const isChecked = newSelected.includes(itemName);
      checkbox.setAttribute(
        "aria-label",
        `${itemName}, ${isChecked ? "selected" : "not selected"}`
      );
    });
  };

  const contentRender = () => (
    <List
      dataSource={filterOptionsList}
      selectionMode="multiple"
      showSelectionControls={true}
      selectedItemKeys={selectedKeys}
      onSelectionChanged={onSelectionChanged}
      onItemRendered={(e) => {
        const checkbox = e.itemElement.querySelector(".dx-checkbox");
        if (checkbox) {
          const itemName = e.itemData;
          const isChecked = selectedKeys.includes(itemName);
          checkbox.setAttribute(
            "aria-label",
            `${itemName}, ${isChecked ? "selected" : "not selected"}`
          );
        }
      }}
    />
  );

  return (
    <FormControl sx={{ width: 250 }}>
      <DropDownBox
          ref={dropDownBoxRef}
          label="Report filter options"
          labelMode="floating"
          height={56}
          width={210}
          value={selectedKeys}
          valueExpr={null}
          displayExpr={null}
          dataSource={filterOptionsList}
          contentRender={contentRender}
          inputAttr={{ "aria-label": "Report filter options dropdown" }}
          dropDownOptions={{ closeOnOutsideClick: true }}
          onKeyDown={(e) => {
              if (e.event.key === "Enter") {
                  e.event.preventDefault();
                  if (dropDownBoxRef.current) {
                      const instance = dropDownBoxRef.current.instance;
                      instance.option("opened") ? instance.close() : instance.open();
                  }
              }
          }}
      />
      <FormHelperText>Select one or more filters</FormHelperText>
    </FormControl>
  );
};

export default SearchBtnGroupSelect;
